import {NgModule} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {UIRouterModule} from '@uirouter/angular';
import {dynamicStateConfigFn, Ng2DynamicStateDeclaration} from '@ngx-ivengi/locale';
import {ArchiveComponent} from './archive.component';

export let CHILD_STATES: Ng2DynamicStateDeclaration[] = [
  {
    name: 'archive',
    component: ArchiveComponent,
    future: true,
    data: {
      pageTitle: 'states.archive.pageTitle',
      scopes: ['datagrid:CLIENT', 'datagrid:EMPLOYEE']
    }
  }
];

@NgModule({
  imports: [
    UIRouterModule.forChild({
      states: CHILD_STATES,
      config: dynamicStateConfigFn
    }),
    TranslateModule
  ],
  exports: [UIRouterModule]
})
export class ArchiveRoutingModule {
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/archive/archive.routes.ts